import React, {useState} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { orderBy } from '@progress/kendo-data-query';

import LoadingIndicator from '../../common/loadingIndicator';
import {channelCell, maskValueCell} from '../../common/sponsorships/list/sponsorshipListHelper';
import { changeUpcomingPublicationListPage, changeUpcomingPublicationListOrder } from '../upcomingPublication.actions';
import { useAuth0, getSelectedTenantId } from '../../app/auth';
import * as selectors from '../upcomingPublication.selectors';


const UpcomingPublicationListComponent = (props) => {

    const [sort, setSort] = useState([{ field: 'date', dir: 'asc'}]);
    const { getTokenSilently, user } = useAuth0();

    const onSortChange = async(event) => {
        setSort(event.sort);
        const token = await getTokenSilently();
        props.onSortChanged(event.sort[0], token, getSelectedTenantId(user, token));
    };

    const handlePageChanged = async(event) => {
        const token = await getTokenSilently();
        props.onPageChanged({
            take: event.page.take,
            skip: event.page.skip
        }, token, getSelectedTenantId(user, token));
    };

    function priceCell(props) {
        return maskValueCell(props, 0);
    }

    const { upcomingPublications, take, skip, total, isLoading } = props;
    

    if(isLoading) return <LoadingIndicator/>;

    return (
        <Grid data={orderBy(upcomingPublications, sort)} 
            sortable sort={sort}
            onSortChange={onSortChange}
            onPageChange={handlePageChanged}
            pageable={{ type: "input"}}
            take={take} skip={skip} total={total}
            className="grid-container">
            <GridColumn field="date" title="Date" format="{0:d-MMM-yy}" className="date-highlight" width="120" locked={true}/>
            <GridColumn field="channelName" title="Channel" cell={channelCell} sortable={false} width="230" locked={true}/>
            <GridColumn field="publicationStatusName" title="Status" cell={priceCell}/> 
            <GridColumn field="price" title="Price" cell={priceCell}/> 
        </Grid>
    );
};

UpcomingPublicationListComponent.propTypes = {
    upcomingPublications: PropTypes.array.isRequired,
    skip: PropTypes.number.isRequired,
    take: PropTypes.number.isRequired,
    isLoading: PropTypes.bool.isRequired,
    total: PropTypes.number,
    onPageChanged: PropTypes.func,
    onSortChanged: PropTypes.func
};

function mapStateToProps(state) {

    const pagination = selectors.getPaginationInfo(state) || {};
    let skip = 0;
    let take = 0;
    if(pagination && Object.keys(pagination).length > 0) {
        skip = pagination.pageSize * (pagination.pageNumber - 1);
        take = pagination.pageSize;
    }
    return {
        upcomingPublications: selectors.getUpcomingPublications(state) || [],
        take,
        skip,
        total: pagination.recordTotal,
        isLoading: selectors.isUpcomingPublicationDataLoading(state) || false

    };
}

function mapDispatchToProps(dispatch) {
    const props = {
      onPageChanged: (options, token, tenantId) => {
        dispatch(changeUpcomingPublicationListPage(options, token, tenantId));
      },
      onSortChanged: (options, token, tenantId) => {
          dispatch(changeUpcomingPublicationListOrder(options, token, tenantId));
      }
    };
    return props;
}
  
const UpcomingPublicationList = connect(mapStateToProps, mapDispatchToProps)(UpcomingPublicationListComponent);
export default UpcomingPublicationList;